module.exports = __webpack_public_path__ + "ebd0e87bfac3d950a05ee587b5cc61fd.dcm";